import {ASPECT_RATIO_TYPES, IMAGE_TYPES, URL_TYPES} from './constants.js'

import {PROVIDER_ADAPTERS} from './config.js' // eslint-disable-line import/no-cycle

export function getUrlType({url}) {
  if (url.includes('https://content.media.ccdn.es/') || url.includes('https://content.media.mcdn.es/'))
    return URL_TYPES.YAMS
  if (url.includes('https://pro.fastly.ccdn.es/')) return URL_TYPES.PRO_FASTLY
  if (url.includes('https://content.fastly.ccdn.es/') || url.includes('https://content.fastly.mcdn.es/'))
    return URL_TYPES.FASTLY
  if (url.includes('https://precf.media.ccdn.es/')) return URL_TYPES.PRECF_MEDIA
  if (url.includes('https://prea.ccdn.es') || url.includes('https://a.ccdn.es') || url.includes('https://a.mcdn.es'))
    return URL_TYPES.PINCHER

  return URL_TYPES.OTHER
}

export function getTransformedImage({imageUrl, options}) {
  const {aspectRatio = ASPECT_RATIO_TYPES.FULL_SCREEN, imageType, imageWidth, transformType} = options

  const urlType = getUrlType({url: imageUrl})

  const adapter = PROVIDER_ADAPTERS[urlType][transformType]

  const transformedImage = adapter({
    aspectRatio,
    imageType,
    src: imageUrl,
    width: imageWidth
  })

  return transformedImage
}

function getPincherCutSize({width, aspectRatio}) {
  const aspectRatioHeight = Math.floor(width / aspectRatio)
  const imageSize = `${width}x${aspectRatioHeight}`
  return imageSize
}

export function getCurrentSource({src}) {
  return src
}

export function getPincherDeviceCropSource({aspectRatio, src, width}) {
  // As pincher is not working fine with crop coordinates + /cut param at the same time, we adapt from these inputs:
  // https://a.ccdn.es/cnet/contents/media/resources/2023/2/1309284.jpg
  // https://a.ccdn.es/cnet/contents/media/resources/2023/2/1309284.jpg/0_0_1280_720/
  //
  // To this output:
  // https://a.ccdn.es/cnet/contents/media/resources/2023/2/1309284.jpg/123x123cut/

  const IMAGE_FORMAT = '.jpg'
  const IMAGE_CUT_PATH = `/${getPincherCutSize({aspectRatio, width})}cut/`
  const splittedUrl = src.split(IMAGE_FORMAT)

  return [splittedUrl[0], IMAGE_FORMAT, IMAGE_CUT_PATH].join('')
}

export function getYamsOriginalSource({src}) {
  return `${src}?rule=${IMAGE_TYPES.ORIGINAL}`
}

export function getFastlyOriginalSource({src}) {
  return `${src}?rule=${IMAGE_TYPES.ORIGINAL}`
}

export function getYamsDeviceCropSource({imageType, src}) {
  return `${src}?rule=${imageType}`
}

export function getFastlyDeviceCropSource({imageType, src}) {
  return `${src}?rule=${imageType}`
}

export function getProFastlyDeviceCropSource({aspectRatio, src, width}) {
  const aspectRatioHeight = Math.floor(width / aspectRatio)
  return `${src}/${width}x${aspectRatioHeight}cut/`
}

export function getPrecfMediaDeviceCropSource({aspectRatio, src, width}) {
  const aspectRatioHeight = Math.floor(width / aspectRatio)
  return `${src}/${width}x${aspectRatioHeight}cut/`
}
